import { ReactNode, useEffect } from 'react';
import styles from './Layout.module.scss';
import Sidebar from '@/components/Layout/Sidebar';
import Header from '@/components/Layout/Header';
import { MenuProvider } from '@/contexts/menuContext';
import { useTheme } from '@/contexts/themeContext';
import Assistant from './Assistant';
import { useAppSelector } from '@/hooks/hooks';
import { isInIframe } from '@/utils/iframeUtils';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

interface MainLayoutProps {
  children?: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { sidebarCollapseState, collapseSidebar } = useTheme();
  const { openAIAssistant } = useAppSelector((state) => state.common);
  const isIframe = isInIframe();
  console.log('isInIframe', isIframe);

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    if (isIframe) {
      collapseSidebar();
    }
  }, [isIframe]);
  return (
    <>
      <MenuProvider>
        {!isIframe && <Header />}
        <div
          className={`${styles.mainLayout} ${openAIAssistant ? 'open-assistant' : ''}`}
        >
          {!isIframe && <Sidebar />}
          <div
            className={
              styles.mainBodyContainer +
              ' ' +
              (isMobile
                ? ''
                : sidebarCollapseState
                  ? styles.sidebarContainerCollapse
                  : '')
            }
            style={{
              marginLeft: isMobile
                ? '0'
                : sidebarCollapseState
                  ? '90px'
                  : '250px',
            }}
          >
            <div
              className={`${styles.mainBody} ${openAIAssistant ? 'mainBodyCollapse' : ''} mainBody`}
            >
              {children}
            </div>
            <Assistant />
          </div>
        </div>
      </MenuProvider>
    </>
  );
};

export default MainLayout;
